export const onChoose = (index) => ({
  type: 'CHOOSE',
  index
})

export const onClear = () => ({
  type: 'CLEAR'
})
